import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slick from 'react-slick';
import styled from 'styled-components';

import { GalleryModalContext } from '../../utils/contexts';
import { Container, Modal, Content } from '../../styles/modals/generic-modal';
import Header from './parts/modal-header';

const Slide = styled.div`
  height: 100%;
  overflow-y: auto;
`;

const SlideImage = styled.img`
  /* max-height: ${props => props.hasCaption ? '60vh' : '80vh'} !important; */
  /* width: auto !important; */
`;

const SlideMarkdownContainer = styled.div`
  height: 20vh;
  padding: 10px;
  /* overflow-y: auto; */
  max-width: 100%;

  b {
    font-weight: bold;
  }
`;

const SlickSlide = ({ url, caption }) => <Slide>
  <SlideImage src={url} hasCaption={caption ? true : false} />
  {caption && <SlideMarkdownContainer>
    {caption}
  </SlideMarkdownContainer>
  }
</Slide>

export default function GalleryModal(props) {

  const settings = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <GalleryModalContext.Consumer>
      {
        ({ isOpen, images, modalStyle, markdownCaptions, setIsOpen }) => {

          if (isOpen) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', (e) => {
              e.preventDefault();
              setIsOpen(false)
            });
          }

          return <Container visible={isOpen} className="bg" onClick={(e) => e.target.classList.contains('bg') && setIsOpen(false)}>
            <Modal style={modalStyle} >
              <Header onCloseClick={() => setIsOpen(false)} />
              <Content verticalCenter >
                {isOpen && <Slick {...settings} className="slick-viewpoints" >
                  {
                    images.map((url, index) => <SlickSlide url={url} index={index} key={"gallery_" + index} caption={markdownCaptions[index]} />)
                  }
                </Slick>}
              </Content>
            </Modal>
          </Container>
        }
      }
    </GalleryModalContext.Consumer>
  );
}